// extracted by mini-css-extract-plugin
export default {"textarea":"O4pP-"};